import React, { useLayoutEffect, useState, Fragment, useEffect, use } from 'react'
import ReactDOM from "react-dom/client";
import { Icon } from "@iconify/react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button, SelectBox, CheckBox } from "devextreme-react";
import TextArea from "devextreme-react/text-area";
import { FundRequestService } from '../../../apis/apiServices/FundRequest';
import { Loader } from '../../Shared/PageLoader';
import Swal from 'sweetalert2';
import DataGrid, {
    Column, MasterDetail, Selection
} from "devextreme-react/data-grid";
import Popup from "devextreme-react/popup";
import { icon } from '@fortawesome/fontawesome-svg-core';

export default function ViewFundRequestComponent_V2(props) {
    debugger
    const user = useSelector((state) => state.user.data);
    console.log("Data from props", props)
    const location = useLocation();
    const navigate = useNavigate();
    const { fundRequestId, IsShowButtons,isShowLedgerBalance } = location.state || {};
    useLayoutEffect(() => {
        const initialize = async () => {
            document.querySelector("#pageTitle").innerHTML = "FR - Fund Request";
            await getFundRequestData(fundRequestId);
        };
        getAttachmentsByRequestIdAndRequestTypeId(fundRequestId, 1);
        initialize();
    }, []);
    const [fundRequestData, setFundRequestData] = useState(null);
    const [approveItemRequest, setApproveItemRequest] = useState({
        selectedItems: []
    });
    const [remarksPopup, setRemarksPopup] = useState({
        remarkType: "itemApproval", // itemApproval, deleteItem, approveFr, backToDraftFr
        title: "Approval",
        isModalVisible: false,
        itemId: 0,
        remarks: "",
    });
    const [error, setError] = useState({});
    const [loading, setLoading] = useState(false)
    const [isRejectModalVisible, setIsRejectModalVisible] = useState(false);
    const [remarks, setRemarks] = useState(null);
    const [charCount, setCharCount] = useState(0);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [frAttachmentData, setFRAttachmentData] = useState(null);

    const getFundRequestData = async () => {
        try {
            let body = { 'fundRequestId': fundRequestId, 'userId': user?.userId }
            const response = await FundRequestService.getFundRequestDetailsByFRId(body)
            setFundRequestData(response?.data);
        } catch (error) {
            console.log("Error getFundRequestData===>", error);
        }
    }

    //Reject (Back to draft FR)
    const handleRejectSubmit = async () => {
        //e.preventDefault();
        const newError = {};

        if (!remarks?.trim()) {
            newError.remarks = "Please enter remarks";
        } else if (remarks?.length > 300) {
            newError.remarks = "Remarks cannot exceed 300 characters";
        }

        // if (!userIdForRejectIOM) {
        //     newError.userIdForRejectIOM = "Please select user";
        // }

        if (Object.keys(newError).length > 0) {
            setError(newError);
            return;
        }

        // No errors, proceed
        setIsRejectModalVisible(false);
        setRemarks("");
        //setUserIdForRejectIOM(null);
        setError({});


        let body = {
            modifiedBy: user.userId,
            fundRequestId: fundRequestData?.fundRequestId,
            serialNo: fundRequestData?.serialNo,
            remarks: remarks || "",
            backToStageIndex: 1,
        };
        setLoading(true)
        const response = await FundRequestService.RejectFundRequest(body);
        setLoading(false)
        if (!response?.isSuccess) {
            Swal.fire(
                "Error!",
                `${response?.data?.message}`,
                "error"
            ).then(() => {
                // if (action === "approveIom") {
                //     window.close();
                // }
            })
            return;
        }
        Swal.fire(
            "Success!",
            `${response?.message}`,
            "success"
        ).then(() => {
            navigate(-1)
        });
    };

    const handleApproveSubmit = async () => {
        const newError = {};

        if (!remarks?.trim()) {
            newError.remarks = "Please enter remarks";
        } else if (remarks?.length > 300) {
            newError.remarks = "Remarks cannot exceed 300 characters";
        } else {
            setError({ remarks: "", userIdForRejectIOM: "" });
        }

        if (Object.keys(newError).length > 0) {
            setError(newError);
            return;
        }

        setIsModalVisible(false);
        setRemarks("");
        setError({});
        let body = {
            modifiedBy: user.userId || 0,
            fundRequestId: fundRequestData?.fundRequestId,
            serialNo: fundRequestData?.serialNo,
            remarks: remarks || "",
            stageIndex: fundRequestData?.currentStageIndex,
        };
        setLoading(true)
        const response = await FundRequestService.approveFundRequest(body);
        setLoading(false)
        if (!response?.isSuccess) {
            Swal.fire(
                "Error!",
                `${response?.data?.message}`,
                "error"
            ).then(() => {
                // if (action === "approveIom") {
                //     window.close();
                // }
            })

            return;
        }
        Swal.fire(
            "Success!",
            `${response?.message}`,
            "success"
        ).then(() => {
            // if (action === "approveIom") {
            //     window.close();
            // }
            if (location?.state?.fromPendingPage === true) {
                navigate(-1);
                //console.log("reduxcount", iomPendingCount);
            } else {
                navigate(-1);
            }
        });
    };

    const deleteFundRequestItem = async (rowData) => {
        try {
            const result = await Swal.fire({
                icon: 'warning',
                title: 'Are you sure?',
                text: 'You want to delete this item?',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
            });

            if (!result.isConfirmed) return;

            let { itemId, itemSerialNo, fundRequestId } = rowData;

            let body = {
                itemId: itemId,
                itemSerialNo: itemSerialNo,
                remark: "",
                fundRequestId: fundRequestId,
                modifiedBy: user?.userId,
            }

            const response = await FundRequestService.deleteFundRequestItemByItemId(body)

            if (response?.isSuccess) {
                Swal.fire({ icon: 'success', title: 'Success', text: response?.message, })
                    .then(() => {
                        getFundRequestData();
                    });
            } else {
                Swal.fire({ icon: 'error', title: 'Error', text: response?.message, })
            }

        } catch (error) {
            console.log("Error approveOrRejectFundRequest===>", error);
        }
    }

    const setIsRemarkModalVisible = (rowData) => {
        setRemarksPopup((prevState) => ({
            isModalVisible: true,
            ...rowData,
        }));
    };

    const handleRejectRemarksChange = (e) => {
        const value = e?.event?.target?.value?.slice(0, 300) || ""; // Auto-trim to 300 chars

        setRemarks(value);
        setCharCount(value.length);

        // Set error only if max limit was hit
        setError((prev) => ({
            ...prev,
            remarks: value.length >= 300
                ? "Remarks cannot exceed 300 characters"
                : "",
        }));
    };

    const handleAproveRemarksChange = (e) => {
        const value = e?.event?.target?.value?.slice(0, 300) || ""; // Auto-trim to 300 chars

        setRemarks(value);
        setCharCount(value.length);

        // Set error only if max limit was hit
        setError((prev) => ({
            ...prev,
            remarks: value.length >= 300
                ? "Remarks cannot exceed 300 characters"
                : "",
        }));
    };

    const getAttachmentsByRequestIdAndRequestTypeId = async (requestId, requestTypeId) => {
        try {
            const response = await FundRequestService.getRequestAttachmentsByRequestId(requestId, requestTypeId)
            setFRAttachmentData(response?.data);
        } catch (error) {
            console.log("Error getAttachmentsByRequestIdAndRequestTypeId===>", error);
        }
    }

    return (
        <Fragment>
            <div className="content">
                <div className='card top-bottom' >
                    <div className='card-body'>
                        <div className='row'>
                            <div className='col-lg-8 col-md-6 col-sm-12'>
                                {IsShowButtons &&
                                    <>
                                        <Button
                                            text={fundRequestData?.nextStageActionType ? fundRequestData?.nextStageActionType : "Send for Approval"}
                                            icon="check"
                                            onClick={() => {
                                                if (fundRequestData?.items?.length === 0) {
                                                    Swal.fire("Warning", "Please Add atleast one vendor", "warning")
                                                    return false;
                                                }
                                                setIsModalVisible(true);
                                            }}
                                            visible={fundRequestData?.currentUserId === user?.userId && fundRequestData?.isApproved === false}
                                            stylingMode="default"
                                            type="success"
                                            className="mr-2"
                                        />
                                        <Button
                                            text="Back to Draft"
                                            icon="back"
                                            visible={fundRequestData?.createdByUserId !== user?.userId && fundRequestData?.currentUserId === user?.userId && fundRequestData?.isApproved === false}
                                            onClick={async () => {
                                                // if (iomData?.reviewerStatusId === 10) {
                                                //     Swal.fire({
                                                //         icon: 'info',
                                                //         title: 'Pending for Review',
                                                //         text: 'This IOM is still pending for review.',
                                                //     });
                                                //     return; // stop here so it doesn't go to confirm dialog
                                                // }
                                                if (fundRequestData?.items?.length === 0) {
                                                    Swal.fire("Warning", "Please Add atleast one vendor", "warning")
                                                    return false;
                                                }
                                                const confirmResult = await Swal.fire({
                                                    title: "Are you sure?",
                                                    text: "Do you want to send the Fund Request back to draft?",
                                                    icon: "warning",
                                                    showCancelButton: true,
                                                    confirmButtonText: "Yes, continue",
                                                    cancelButtonText: "No, cancel"
                                                });

                                                if (confirmResult.isConfirmed) {
                                                    setIsRejectModalVisible(true);
                                                }
                                            }}
                                            stylingMode="default"
                                            type="danger"
                                            className="mr-2"
                                            hint="Back to Draft"
                                        /></>}
                            </div>
                            <div className='col-lg-4 col-md-6 col-sm-12 text-right'>
                                <Button
                                    text="Back"
                                    icon="back"
                                    onClick={() => {
                                        navigate(-1);
                                    }}
                                    stylingMode="outlined"
                                    type="default"
                                    className='mr-2'
                                    hint='Back'
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className={'col-lg-9 col-md-6'}>
                        <div className='card' >
                            <div className='card-body'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-12'>
                                        <table className='request-details'>
                                            <tr>
                                                <td><Icon icon="hugeicons:file-02" className='iconify-style' /></td>
                                                <td>
                                                    <div className='fieldlable'>Request No.</div>
                                                    <div className='fieldvalue'>{fundRequestData?.serialNo}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div className='col-lg-3 col-md-3 col-sm-12'>
                                        <table className='request-details'>
                                            <tr>
                                                <td><Icon icon="material-symbols:date-range-outline-rounded" className='iconify-style' /></td>
                                                <td>
                                                    <div className='fieldlable'>Created On</div>
                                                    <div className='fieldvalue'>{fundRequestData?.createdOn}M</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div className='col-lg-3 col-md-3 col-sm-12'>
                                        <table className='request-details'>
                                            <tr>
                                                <td><Icon icon="mdi:flowchart-outline" className='iconify-style' /></td>
                                                <td>
                                                    <div className='fieldlable'>Site</div>
                                                    <div className='fieldvalue'>{fundRequestData?.projectName}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div className='col-lg-3 col-md-3 col-sm-12'>
                                        <table className='request-details'>
                                            <tr>
                                                <td><Icon icon="mdi:flowchart-outline" className='iconify-style' /></td>
                                                <td>
                                                    <div className='fieldlable'>Department</div>
                                                    <div className='fieldvalue'>{fundRequestData?.departmentName}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div className='col-lg-3 col-md-3 col-sm-12'>
                                        <table className='request-details'>
                                            <tr>
                                                <td><Icon icon="tabler:category-2" className='iconify-style' /></td>
                                                <td>
                                                    <div className='fieldlable'>Category</div>
                                                    <div className='fieldvalue'>{fundRequestData?.categoryName}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div className='col-lg-6 col-md-3 col-sm-12'>
                                        <table className='request-details'>
                                            <tr>
                                                <td><Icon icon="material-symbols:subject-rounded" className='iconify-style' /></td>
                                                <td>
                                                    <div className='fieldlable'>Subject</div>
                                                    <div className='fieldvalue'>{fundRequestData?.subject}</div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='card' >
                            <div className='card-body'>
                                <DataGrid
                                    dataSource={fundRequestData?.items || []}
                                    columnAutoWidth
                                    showBorders
                                    showRowLines
                                    showColumnLines={false}
                                    noDataText="No details"
                                    className='selectable-grid'
                                >
                                    {/* <Selection mode="multiple" showCheckBoxesMode="always" /> */}
                                    {/* <Column
                                        caption=""
                                        width={50}
                                        cellRender={({ data }) => {
                                            return (
                                                <>
                                                    {(!fundRequestData.isApproved && fundRequestData?.currentUserId === user?.userId) ?
                                                        <span title="" onClick={() => deleteFundRequestItem(data)} >
                                                            <Icon icon="material-symbols:delete-outline-rounded" className='iconify-style'
                                                            />
                                                        </span>
                                                        :
                                                        <span title="" >
                                                            <Icon icon="material-symbols:delete-outline-rounded" className='iconify-style'
                                                                style={{ cursor: 'pointer', pointerEvents: 'none', opacity: '0.3' }}
                                                            />
                                                        </span>
                                                    }
                                                </>
                                            )
                                        }}
                                    /> */}
                                    <Column dataField="itemSerialNo" caption="Sr no." />
                                    <Column dataField="vendorName" caption="Vendor" />
                                    <Column dataField="bankName" caption="Bank" />
                                    {isShowLedgerBalance && <Column dataField="balanceAmt" caption="Ledger Balance" cellRender={(e) => (
                                        <div> {e.data?.balanceAmt?.toLocaleString("en-IN", {})} </div>
                                    )} />  }
                                   
                                    <Column dataField="recommendedAmt" caption="Recommended Amt." cellRender={(e) => (
                                        <div> {e.data?.recommendedAmt?.toLocaleString("en-IN", {})} </div>
                                    )} />
                                    <Column dataField="advPaymentRequestId" caption="Advance Request ID" allowEditing={false}/>
                                    <Column dataField="remarks" caption="Remarks" visible={false} />
                                </DataGrid>

                                <div className="row mt-4">
                                    {fundRequestData?.actionDetails?.map((stage, index) => (
                                        <div key={index} className="col-lg-4 col-md-12 col-sm-4 d-flex align-items-start">
                                            <div className="w-100">
                                                <label className="form-label">{stage?.status} By,</label>
                                                {stage?.approvers?.map((approver, i) => (
                                                    <input
                                                        key={i}
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        value={`${approver?.firstName + " " + approver?.lastName} (${approver?.designation})`}
                                                        readOnly
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-3 col-md-3 reviews'>
                        <div className='card' >
                            <div className='card-body'>
                                <div className='mb-1 sub-title-color'>REMARKS</div>
                                <div class="list-group">
                                    {fundRequestData?.history?.map((item, index) => (
                                        <div
                                            key={index}
                                            className="list-group-item list-group-item-action flex-column align-items-start" style={{ borderBottom: '1px solid #cfcfcf', marginBottom: '0.5rem', paddingBottom: '0.5rem' }}
                                        >
                                            <div className='small mb-1' style={{ color: '#282c7d', fontWeight: '500' }}>
                                                {item.approvalStatusName === 'Recall' ? "Recall Requested" : item.approvalStatusName} by {item.userFirstName + " " + item.userLastName}
                                            </div>
                                            <div className="d-flex w-100 justify-content-between align-items-center">
                                                <small>Message</small>
                                                <small>
                                                    {item.updatedOn
                                                        ? new Date(item.updatedOn).toLocaleDateString('en-GB', {
                                                            day: '2-digit',
                                                            month: '2-digit',
                                                            year: 'numeric'
                                                        }) +
                                                        ' ' +
                                                        new Date(item.updatedOn).toLocaleTimeString('en-GB', {
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: true
                                                        })
                                                        : ''}
                                                </small>
                                            </div>
                                            <div className="small" style={{ fontSize: '0.8rem', fontStyle: 'italic' }}>{item?.remark}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        {/* Attachments */}
                        {frAttachmentData?.length === 0 ? "" :
                            <div className='card'>
                                <div className='card-body'>
                                    <div className='mb-1 sub-title-color'>ATTACHMENTS</div>
                                    {frAttachmentData?.map((item, index) => (
                                        <div class="list-group">
                                            <div
                                                key={index}
                                                className='list-group-item list-group-item-action flex-column align-items-start' style={{ borderBottom: '1px solid #cfcfcf', marginBottom: '0.5rem', paddingBottom: '0.5rem' }}>
                                                <div class="d-flex w-100 justify-content-between align-items-center">
                                                    <small
                                                        style={{ cursor: 'pointer', color: 'blue' }}

                                                        onClick={() => {
                                                            const fileUrl =
                                                                process.env.REACT_APP_CDN_VISHWAM_BASE_URL +
                                                                item?.filePath;
                                                            window.open(fileUrl, '_blank');
                                                        }}
                                                    >
                                                        {item?.fileName}
                                                        {/* item?.fileType */}
                                                    </small>
                                                    <small>{item?.fileSize} kb</small></div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div className='web-page-footer'>
                    www.vishwasamudra.in
                </div>
            </div>
            {/* Approval PopUp */}
            <Popup
                visible={isModalVisible}
                onHiding={() => setIsModalVisible(false)}
                showTitle={true}
                title="Approval"
                height="auto"
                weight="auto"
                className='custom-modal-popup'
            >
                <div className='popup-body'>
                    <div className='form-group'>
                        <label>Remark <span className="text-danger">*</span></label>
                        <TextArea
                            value={remarks}
                            onInput={(e) => handleAproveRemarksChange(e)}
                            height={90}
                            placeholder="Type your remarks..."
                            maxLength={300}
                        />
                        <div style={{ fontSize: "12px", color: charCount > 300 ? "red" : "#999" }}>
                            {charCount}/300 characters
                        </div>
                        {error.remarks && (
                            <div style={{ color: "red" }}>{error.remarks}</div>
                        )}
                    </div>

                </div>
                <div className='text-right'>

                    <Button
                        icon='close'
                        text="Cancel"
                        onClick={() => {
                            setIsModalVisible(false);
                            setRemarks("");
                            setError("");
                        }}
                        stylingMode="outlined"
                        className="btn btn-outline-primary btn-sm mr-2" />
                    <Button
                        icon='check'
                        text="Submit"
                        type="success"
                        onClick={handleApproveSubmit}
                        className="btn btn-primary btn-sm"
                    />
                </div>
            </Popup>
            {/* Reject PopUp */}
            <Popup
                visible={isRejectModalVisible}
                onHiding={() => setIsRejectModalVisible(false)}
                dragEnabled={false}
                showTitle={true}
                title="Back to Draft"
                height="auto"
                weight="auto"
                className='custom-modal-popup'
            >
                <div className='popup-body'>
                    <div className='form-group'>
                        <label>Sent to <span className="text-danger">*</span></label>
                        <div>
                            <SelectBox
                                dataSource={fundRequestData?.actionDetails?.find(f => f.stageIndex === 1)?.approvers}
                                valueExpr="userId"
                                displayExpr={(item) =>
                                    item ? `${item?.firstName} ${item?.lastName} (${item?.designation})` : ""
                                }
                                className="form-control"
                                placeholder="Select user"
                                searchEnabled
                                disabled={true}
                                showClearButton={true}
                                value={fundRequestData?.createdByUserId}
                            // onValueChanged={(e) => {
                            //     setUserIdForRejectIOM(e.value);
                            // }}
                            //onValueChanged={(e) => handleUserRejectChange(e)}
                            />
                            {error.userIdForRejectIOM && (
                                <div style={{ color: "red" }}>{error.userIdForRejectIOM}</div>
                            )}
                        </div>
                    </div>
                    <div className='form-group'>
                        <label>Remark <span className="text-danger">*</span></label>
                        <div>
                            <TextArea
                                value={remarks}
                                onInput={(e) => handleRejectRemarksChange(e)}
                                height={90}
                                placeholder="Type your remarks..."
                                maxLength={300}
                            />
                            <div style={{ fontSize: "12px", color: charCount > 300 ? "red" : "#999" }}>
                                {charCount}/300 characters
                            </div>
                            {error.remarks && (
                                <div style={{ color: "red" }}>{error.remarks}</div>
                            )}
                        </div>
                    </div>


                </div>
                <div className='text-right'>
                    <Button icon='close'
                        text="Cancel"
                        onClick={() => {
                            setIsRejectModalVisible(false);
                            setRemarks("");
                            setError("");
                        }}
                        stylingMode="outlined"
                        className="btn btn-outline-primary btn-sm mr-2"
                    />
                    <Button
                        icon='check'
                        text="Submit"
                        type="success"
                        onClick={handleRejectSubmit}
                        className="btn btn-primary btn-sm"
                    />
                </div>
            </Popup>
            {loading && <Loader loadingMessage={""} />}
        </Fragment>
    )
}
